'use client'

import type { ComponentProps } from 'react'
import type { User } from '@/src/services/user'
import { cn } from '@/src/utils/styles'
import { Button } from '../ui/button'
import { type Avatar, AvatarImage, DEFAULT_AVATAR } from './avatar'

interface AccountButtonProps extends ComponentProps<typeof Button> {
  user: User
  avatar?: Avatar | 'not-set'
  imageLayoutId?: string
}

export const AccountButton = ({
  className,
  user,
  avatar,
  imageLayoutId,
  ...buttonProps
}: AccountButtonProps) => {
  // Guest mode
  if (user.id === 'guest') {
    return (
      <Button
        variant='outline'
        size={{
          default: 'sm',
          sm: 'md',
        }}
        className={cn(
          'pl-1 sm:pl-2 bg-background-80 backdrop-blur-xl gap-3',
          className,
        )}
        {...buttonProps}
      >
        <AvatarImage
          avatar='cloud-man'
          className='w-5 h-5 sm:w-8 sm:h-8 object-cover'
        />
        <span>Guest</span>
      </Button>
    )
  }

  return (
    <Button
      variant='outline'
      size={{
        default: 'sm',
        sm: 'md',
      }}
      className={cn(
        className,
        'pl-1 sm:pl-2 bg-background-80 backdrop-blur-xl gap-3',
      )}
      {...buttonProps}
    >
      <div className='flex items-center gap-3'>
        <AvatarImage
          avatar={avatar && avatar !== 'not-set' ? avatar : DEFAULT_AVATAR}
          layoutId={imageLayoutId}
          className='w-5 h-5 sm:w-8 sm:h-8'
        />
        {user.name}
      </div>
    </Button>
  )
}
